import React, { useState } from "react";
import { useEffect } from "react";
import CustomAlert from "./CustomAlert";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import { fetchRoomNoAndPhoneNo, setRoomNoAndPhoneNo } from "../../utils/util";
import { useNavigate } from "react-router-dom";
import { HKServiceSubmitButtonClick } from "../../utils/Analytics";

function Requestable(props) {
  const navigate = useNavigate();
  const [requestableList, SetRequestableList] = useState([]);
  const [selectedItems, SetSelectedItems] = useState([]);
  const reservationId = localStorage.getItem("reservationId");
  const guestId = localStorage.getItem("guestId");
  const hotelId = localStorage.getItem("hotel-id");
  const appUserId = localStorage.getItem("appUserId");
  const [customAlertMsg, SetCustomAlertMsg] = useState("");
  const [roomNumberError, setRoomNumberError] = useState("");
  const [customAlertDescription, SetCustomAlertDescription] = useState("");
  const [loadingAnimation, SetLoading] = useState(false);
  const [successShow, SetSuccess] = useState(false);
  const [errorShow, SetErrorShow] = useState(false);
  const [old_data, SetOldData] = useState([]);
    const [currencySymbol, setCurrencySymbol] = useState("");
  const handleCart = (event) => {
    const itemId = event.target.id;
    const isSelected = selectedItems.some((item) => item.serviceId === itemId);
    if (isSelected) {
      const updatedItems = selectedItems.filter(
        (item) => item.serviceId !== itemId
      );
      SetSelectedItems(updatedItems);
    } else {
      SetSelectedItems([...selectedItems, { serviceId: itemId, requested: 1 }]);
    }
  };
  const storedData = fetchRoomNoAndPhoneNo();

  const [roomNo, setRoomNo] = useState(storedData?.room);
  const [confirmRoomNo, setConfirmRoomNo] = useState(storedData?.room);
  const [requestShow, SetRequestShow] = useState(false);

  const handleRoomNo = (e) => {
    setRoomNo(e.target.value);
  };

  const handleConfirmRoomNo = (e) => {
    setConfirmRoomNo(e.target.value);
  };

  const handleRequest = () => {
    SetRequestShow(true);
  };

  const handleClose = () => {
    SetRequestShow(false);
  };

  useEffect(() => {
    SetRequestableList(props.requestableList);
    SetOldData(props.requestableList);
    setCurrencySymbol(props.currencySymbol);
  }, [props.requestableList]);

  let gst = requestableList[0]?.gst;
  const requestService = async () => {
    let data = JSON.stringify({
      roomNumber: roomNo,
      guestId: guestId,
      hotelId: hotelId,
      appUserId: appUserId,
      reservationId: reservationId,
      gst: gst,
      serviceType: 1,
      items: selectedItems,
    });
    let config = {
      method: "post",
      url: `${baseURL}/api/serviceV21`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    try {
      SetLoading(true);
      const response = await axios.request(config);
      if (response.data.success) {
        SetSuccess(true);
        SetCustomAlertMsg("Requested Successfully");
        setRoomNoAndPhoneNo(roomNo)
        SetRequestableList([]);
        setTimeout(() => {
          SetRequestableList(old_data);
        }, [100]);
        SetSelectedItems([]);
        setTimeout(() => {
          SetCustomAlertMsg("");
          SetSuccess(false);
          navigate("../order-history")
        }, 2000);
      }else{
        SetErrorShow(true);
        SetCustomAlertMsg(response.data?.message);
        setTimeout(() => {
          SetCustomAlertMsg("");
          SetErrorShow(false);
        }, 4000);
      }
      SetLoading(false);
    } catch (error) {
      console.log(error);
      SetLoading(false);
      SetErrorShow(true);
      SetCustomAlertMsg("Sorry.. Something went wrong");
      setTimeout(() => {
        SetCustomAlertMsg("");
        SetErrorShow(false);
      }, 4000);
    }
  };
  const submitRequest = () => {
    SetCustomAlertMsg("");
    if(roomNo == ''){
      setRoomNumberError("Enter Room Number");
    }else if(confirmRoomNo == ""){
      setRoomNumberError("Enter Confirm Room Number");
    }else if (roomNo !== confirmRoomNo) {
      setRoomNumberError("Room Numbers Not Match");
    } else {   
      HKServiceSubmitButtonClick();
      requestService();
    }
  };

  return (
    <div className="gridTab grid grid-flow-row grid-cols-1 gap-3 gap-x-4 mt-5">
      <>
      {requestableList.map((item, i) => (
        <div
          key={i}
          className="flex flex-row sm:flex-col  items-center p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
        >
          <div className="relative sm:w-full flex bg-gray-200 rounded-md overflow-hidden sm:h-[160px] w-[56px] h-[56px]">
            <img
              width="100%"
              height="100%"
              className={`flex items-stretch bg-contain object-cover transition w-full sm:h-full ${
                props.active?.is_open == 1 ? "" : "filter grayscale" }`}
              src={item.image}
              alt=""
            />
            <div className="hidden sm:block absolute w-6 h-6 sm:top-2 top-1/3 sm:right-8 right-4 ">
              <input
                id={item.id}
                onChange={handleCart}
                className="w-full h-full"
                type="checkbox"
                name=""
              />
            </div>
          </div>
          <div className="py-3 relative flex flex-row gap-2 justify-between w-full lg:ml-0 ml-2 lg:pr-0 pr-2 ">
            <div className="flex-col pl-[10px] sm:pl-0">
              <div className="sm:mt-2 mt-0 sm:text-base text-[14px] font-medium">
                {item.name}
              </div>
              <div className="flex w-full justify-between items-center">
                <div className="mt-1 sm:text-xs text-[11px] text-[#9A9A9A] font-medium">
                {item.rate == "Free" ? item.rate : `${currencySymbol}${item.rate}${item.gst !== null ? ` + ${item.gst} % GST` : ''}`}
                </div>
              </div>
              {  props.active?.is_open == 1 && 
                <div className="sm:hidden absolute w-6 h-6 sm:top-2 top-1/3 sm:right-8 right-4 ">
                  <input
                    id={item.id}
                    onChange={handleCart}
                    className="w-full h-full"
                    type="checkbox"
                    name=""
                  />
                </div>
              }
            </div>
          </div>
        </div>
      ))}
      </>
      {selectedItems.length != 0 && (
        <div className="place-order-div">
          <div className="place-order">
            <button onClick={handleRequest}>Place order</button>
          </div>
        </div>
      )}

      {requestShow && (
        <Transition appear show as={Fragment}>
          <Dialog
            as="div"
            className="relative z-[999999]"
            onClose={handleClose}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-lg min-h-[300px] transform overflow-hidden rounded-xl bg-[#2E2842] p-6 text-left align-middle shadow-xl transition-all relative food-modal">
                    <Dialog.Title
                      as="h3"
                      className="text-left text-lg font-semibold"
                    >
                      <div className="modalBar mx-auto"></div>
                      <div className="text-left text-white text-lg font-semibold mt-6">
                        House Keeping services
                      </div>
                      <label
                        className="plcLabel pt-4"
                        style={{ color: "gray" }}
                      >
                        Room Number
                      </label>
                      <input
                        className="mt-2 p-2"
                        type="text"
                        value={roomNo}
                        onChange={handleRoomNo}
                        required
                      />
                      <label className="plcLabel" style={{ color: "gray" }}>
                        Confirm Room number
                      </label>
                      <input
                        className="mt-2 p-2"
                        type="text"
                        value={confirmRoomNo}
                        onChange={handleConfirmRoomNo}
                        required
                      />
                      {roomNumberError != "" && <h6 className="text-[red] text-[11px]">{roomNumberError}</h6> }
                      <button
                        disabled={loadingAnimation}
                        onClick={submitRequest}
                        className="bookBtn mt-4 relative"
                      >
                        <span> Request service</span>
                        {loadingAnimation && <ButtonLoader />}
                      </button>
                    </Dialog.Title>
                    <div className="mt-2  w-full flex justify-end items-center confirm-order">
                      <div className="flex items-center gap-3"></div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      )}

      {customAlertMsg != "" && (
        <CustomAlert
          hide={() => {
            SetCustomAlertMsg("");
            SetSuccess(false);
            SetCustomAlertDescription("");
            SetErrorShow(false);
          }}
          heading={customAlertMsg}
          para={customAlertDescription}
          successShow={successShow}
          errorShow={errorShow}
          submitRequest={submitRequest}
        />
      )}
    </div>
  );
}

export default Requestable;
